const services = [
  {
    icon: "ri-tree-line",
    tag: "01 · Log Chipping",
    title: "원목칩 생산",
    desc: "800mm 대형 원목까지 투입 가능한 JENZ 칩핑기로 균일한 사이즈의 고품질 원목칩을 생산합니다.",
    bullets: ["보일러/발전용", "축산 깔개용", "조경·복토용"],
    image: "/uploads/home-service-chip.webp",
  },
  {
    icon: "ri-scissors-cut-line",
    tag: "02 · Branch Chipping",
    title: "가지칩 파쇄",
    desc: "임지에 방치되기 쉬운 벌목 부산물과 가지류를 현장에서 바로 파쇄해 처리 비용과 부피를 줄입니다.",
    bullets: ["임지 잔재 정리", "농·임가 즉시 활용", "생분해 멀칭"],
    image: "/uploads/home-service-branch.webp",
  },
  {
    icon: "ri-hammer-line",
    tag: "03 · Root Grinding",
    title: "뿌리·그루터기 파쇄",
    desc: "부지 정리, 조림지 재활용을 위해 대형 뿌리와 그루터기를 강력한 출력으로 안정적으로 파쇄합니다.",
    bullets: ["부지 조성 사전 작업", "그루터기 완전 제거", "재조림 전 정지"],
    image: "/uploads/home-service-root.jpg",
  },
  {
    icon: "ri-recycle-line",
    tag: "04 · Recycling",
    title: "자원 재활용 컨설팅",
    desc: "발생 부산물의 용도별 최적 사이즈 산정, 이송·판매 채널까지 파쇄 전 과정을 종합 제안합니다.",
    bullets: ["스크린 사이즈 컨설팅", "물량 계획 수립", "수급처 연결 지원"],
    image: "/uploads/home-service-recycling.jpg",
  },
];

import ScrollReveal from "@/components/ScrollReveal";
import { resolveImageUrl } from "@/lib/api";

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <ScrollReveal direction="up" delay={100}>
            <div className="inline-flex items-center gap-2 text-primary-700 text-xs tracking-[0.3em] uppercase font-medium mb-5">
              <span className="w-8 h-px bg-primary-500"></span>
              Our Services
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
              원목부터 뿌리까지,
              <br />
              <span className="text-primary-700">파쇄의 모든 과정</span>을 담습니다.
            </h2>
            <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
              임지 정리, 조림 부지 조성, 자원 순환까지 &mdash; 우공이산은 국내
              산림 현장이 필요로 하는 파쇄 서비스 전 범위를 한 팀에서 책임집니다.
            </p>
          </ScrollReveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((s, i) => (
            <ScrollReveal key={s.title} direction="up" delay={150 + i * 150}>
              <div className="group relative rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-400 transition-all duration-500">
                <div className="relative w-full h-56 md:h-64 overflow-hidden">
                  <img
                    src={resolveImageUrl(s.image)}
                    alt={`${s.title} 서비스 이미지`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>
                  <div className="absolute top-5 left-5 flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/95 backdrop-blur text-xs font-medium text-foreground-800 tracking-wide">
                    <i className={`${s.icon} text-primary-700 w-4 h-4 flex items-center justify-center`}></i>
                    {s.tag}
                  </div>
                  <div className="absolute bottom-5 left-5 text-background-50 font-heading text-2xl md:text-3xl font-bold">
                    {s.title}
                  </div>
                  <div className="absolute top-5 right-5 w-9 h-9 rounded-full bg-background-50/90 flex items-center justify-center text-foreground-900 text-sm font-bold">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>

                <div className="p-6 md:p-7">
                  <p className="text-foreground-700 text-sm md:text-[15px] leading-relaxed">
                    {s.desc}
                  </p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.bullets.map((b) => (
                      <span
                        key={b}
                        className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap"
                      >
                        # {b}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}